// 研发活动
import {useEffect, useState} from "react";
import {Button, Descriptions, Form, Input, Row, DatePicker, Select, Col, Space, Typography, Tag} from "antd";
import {gql, useMutation, useSubscription} from "@apollo/client";
import {
    内部研究开发费用说明,
    研发活动日期字段,
    研发职务工作内容,
    研究经费总预算字段,
    研究经费近三年总支出字段
} from "./config";
import {bigIntMoney10000ToString, money10000ToString, string10000ToMoney} from "./Utils";
import {UploadOutlined} from '@ant-design/icons';
import {SelectUpload} from "./component/SelectUpload";
import {Attachments} from "./component/Attachments";
import {chatAI} from "./chatAI";
import {PrintPDF} from "./component/PrintPDF";


const {Title, Paragraph, Text, Link} = Typography;

const dayjs = require('dayjs')


const {TextArea} = Input;

export default function Yfhd() {
    const [value, setValue] = useState(window.location.hash.split("?")[1] || '');
    // 研发人员
    const [yfry, setYfry] = useState({cy: [], ps: []})
    // 研究开发费用明细
    const [kffy, setKffy] = useState({})
    const [kffyys, setKffyys] = useState({})
    const handleChange = (newValue) => {
        setValue(newValue);
        window.location.hash = (window.location.hash.split("?")[0] || window.location.hash) + '?' + newValue
    };

    const [form] = Form.useForm();

    const {data: theRDData, loading: theMndsbDataLoading} = useSubscription(
        gql`subscription MySubscription($id: uuid = "") {
            research_development_by_pk(id: $id) {
                PHxjs
                PLxmd
                PQdcg
                created_at
                dataEprPJssj
                dataEprPQzsj
                hcod
                id
                mndsb
                mndsbObj {
                    _glykj
                    _jscxgl
                    _kjcgzh
                    _zscqjz
                    basics_cost
                    china_cost
                    company
                    created_at
                    companyObj {
                        clsj
                        created_at
                        id
                        qymc
                        tyshxydm
                        updated_at
                        qyjj
                        qyjc
                    }
                    ent_hr_abroed
                    ent_hr_age1
                    ent_hr_age2
                    ent_hr_age3
                    ent_hr_age4
                    ent_hr_bachelor
                    ent_hr_doctor
                    ent_hr_ext
                    ent_hr_forg
                    ent_hr_junior
                    ent_hr_master
                    ent_hr_mechanic
                    ent_hr_middle
                    ent_hr_on_job
                    ent_hr_part
                    ent_hr_primary
                    ent_hr_senior
                    ent_hr_total
                    ent_hr_tsdplan
                    enterprise_income
                    id
                    net_asset1
                    net_asset2
                    net_asset3
                    sales_revenue1
                    sales_revenue2
                    sales_revenue3
                    sat_hr_abroed
                    sat_hr_ext
                    sat_hr_forg
                    sat_hr_on_job
                    sat_hr_part
                    sat_hr_total
                    sat_hr_tsdplan
                    total_profit1
                    total_profit2
                    total_profit3
                    updated_at
                    year
                    players {
                        IDNumber
                        age
                        created_at
                        id
                        mndsb
                        name
                        number
                        post
                        professional
                        school
                        status
                        xueli
                        updated_at
                    }
                }
                spending
                updated_at
                yproductName
                zc1
                zc2
                zc3
                jslyList
                attachments {
                    created_at
                    description
                    id
                    item
                    name
                    path
                    text
                    updated_at
                }
                XMYJBJHBYX
                YJNRHXJSHCXD
                YQMBJKHZB
                SSJDJHHJDMB
                YQCSDJJXYFX
                players{
                    id
                    playerObj {
                        IDNumber
                        age
                        created_at
                        id
                        mndsb
                        name
                        number
                        post
                        professional
                        school
                        updated_at
                        xueli
                    }
                }
                kffymxs{
                    created_at
                    fillUser
                    fillUserDate
                    id
                    mndsb
                    nbyjkftr
                    nwhj
                    orderNo
                    pjnwbtrhj
                    qtfy
                    research_development
                    ryrg
                    sbtsf
                    sjf
                    updated_at
                    wtwbyjkftr
                    wxzc
                    xmbh
                    yearsAgo
                    zjfy
                    zjtr
                }
            }
        }`, {
            variables: {id: value},
            shouldResubscribe: true
        },
    );
    useEffect(() => {
        if (theRDData) {
            if (theRDData.research_development_by_pk.players.length > 1 && theRDData.research_development_by_pk.players.length < 11) {
                setYfry({
                    cy: theRDData.research_development_by_pk.players.map(p => p.playerObj).slice(0, theRDData.research_development_by_pk.players.length - 1),
                    ps: theRDData.research_development_by_pk.players.map(p => p.playerObj).slice(-1)
                })
            }
            if (theRDData.research_development_by_pk.players.length > 10) {
                setYfry({
                    cy: theRDData.research_development_by_pk.players.map(p => p.playerObj).slice(0, theRDData.research_development_by_pk.players.length - 3),
                    ps: theRDData.research_development_by_pk.players.map(p => p.playerObj).slice(-3)
                })
            }
            const kffy = {}
            let sum = 0
            theRDData.research_development_by_pk.kffymxs.map(mx => {
                内部研究开发费用说明.map(sm => {
                    sum += mx[sm[0]]
                    if (kffy[sm[0]]) {
                        kffy[sm[0]] += mx[sm[0]]
                    } else {
                        kffy[sm[0]] = mx[sm[0]]
                    }
                })
            })
            kffy.sum = sum
            setKffy(kffy)
            const kffyys = {}
            let ysSum = 0
            内部研究开发费用说明.map(sm => {
                const random = Math.random() * 5
                if (kffy[sm[0]] > 0) {
                    ysSum += Math.round(kffy[sm[0]] / 1000000 + random)
                    if (kffyys[sm[0]]) {
                        kffyys[sm[0]] += Math.round(kffy[sm[0]] / 1000000 + random)
                    } else {
                        kffyys[sm[0]] = Math.round(kffy[sm[0]] / 1000000 + random)
                    }
                }
            })
            kffyys.sum = ysSum
            setKffyys(kffyys)
        }
    }, [theRDData])
    const [update_research_development_by_pk, {error}] = useMutation(gql`mutation MyMutation($id: uuid = "", $research_development: research_development_set_input = {}) {
        update_research_development_by_pk(pk_columns: {id: $id}, _set: $research_development) {
            id
        }
    }
    `);

    const yfhdInitialValues = {...(theRDData || {}).research_development_by_pk};
    if ((theRDData || {}).research_development_by_pk) {
        for (let k of 研究经费总预算字段) {
            if ((theRDData || {}).research_development_by_pk[k]) {
                yfhdInitialValues[k] = money10000ToString((theRDData || {}).research_development_by_pk[k])
            }
        }
        for (let k of 研发活动日期字段) {
            if ((theRDData || {}).research_development_by_pk[k]) {
                yfhdInitialValues[k] = dayjs((theRDData || {}).research_development_by_pk[k])
            }
        }
    }
    // const getFields = () => {
    //     const children = [];
    //     for (let i = 0; i < 16; i++) {
    //         children.push(
    //             <Col span={i % 4 === 0 ? 3 : 7} key={i}>
    //                 {[5, 6, 7, 9, 10, 11, 13, 14, 15].indexOf(i) >= 0 ? <Form.Item
    //                     name={研究经费近三年总支出字段[[5, 6, 7, 9, 10, 11, 13, 14, 15].indexOf(i)]}
    //                     // label={`Field ${i}`}
    //                     rules={[
    //                         {
    //                             required: true,
    //                             message: '请输入内容！',
    //                         },
    //                     ]}
    //                 >
    //                     <Input placeholder="请输入"/>
    //
    //                 </Form.Item> : <>{[ parseInt(theRDData.research_development_by_pk.year) - 3,  parseInt(theRDData.research_development_by_pk.year) - 2, parseInt(theRDData.research_development_by_pk.year) - 1][i]}</>}
    //             </Col>,
    //         );
    //     }
    //     return children;
    // };
    const inputs = (form) => [
        ['目的及组织实施方式（限400字）', 'PLxmd', `请帮我编写${form.getFieldValue('yproductName')}项目中的研究背景及组织实施方式和步骤`],
        ['核心技术及创新点（限400字）', 'PHxjs', `请帮我编写${form.getFieldValue('yproductName')}项目中的核心技术（含具体数据）和创新点分开写`],
        ['取得的阶段性成果（限400字）', 'PQdcg', `请帮我编写在${form.getFieldValue('yproductName')}项目中取得的阶段性成果（含具体参数）`],
        ['项目研究背景和必要性', 'XMYJBJHBYX', `请帮我编写${form.getFieldValue('yproductName')}项目中的研究背景及必要性`],
        ['研究内容、核心技术和创新点', 'YJNRHXJSHCXD', `请帮我编写${form.getFieldValue('yproductName')}项目中的研究内容、核心技术（包含具体参数）和创新点`],
        ['预期目标及考核指标', 'YQMBJKHZB', `请帮我编写${form.getFieldValue('yproductName')}项目预期目标及考核指标（含具体参数）`],
        ['实施进度计划和阶段目标', 'SSJDJHHJDMB', `请帮我用HTML语言以表格的形式编写${form.getFieldValue('yproductName')}项目的进度计划，包括序号，开始时间，完成时间，进度安排和阶段目标，技术内容等，从${(form.getFieldValue('dataEprPQzsj') || {}).$y}年${(form.getFieldValue('dataEprPQzsj') || {}).$M + 1}月开始，到${(form.getFieldValue('dataEprPJssj') || {}).$y}年${(form.getFieldValue('dataEprPJssj') || {}).$M + 1}月完成。`],
        ['预期产生的经济效益分析', 'YQCSDJJXYFX', `请帮我分析${form.getFieldValue('yproductName')}预期产生的经济效益`],
    ]

    return (<>
        <div style={{display: 'flex', alignItems: 'center'}}>
            <label title={'RD ID'} style={{width: '70px'}}>RD ID：</label>
            <Input value={value} onChange={(e) => {
                handleChange(e.target.value)
            }}/>
        </div>
        <div style={{padding: '10px'}}></div>
        {(theRDData || {}).research_development_by_pk && <>
            <Descriptions title="" bordered>
                <Descriptions.Item label="企业名称"
                                   span={2}>{theRDData.research_development_by_pk.mndsbObj.companyObj.qymc}</Descriptions.Item>
                <Descriptions.Item label="申报年度"
                                   span={2}>{theRDData.research_development_by_pk.mndsbObj.year}</Descriptions.Item>
                <Descriptions.Item label="统一社会信用代码"
                                   span={2}>{theRDData.research_development_by_pk.mndsbObj.companyObj.tyshxydm}</Descriptions.Item>
                <Descriptions.Item
                    label="成立时间"
                    span={2}>{new Date(theRDData.research_development_by_pk.mndsbObj.companyObj.clsj).toLocaleDateString()}</Descriptions.Item>
                <Descriptions.Item label="研发活动编号 RD"
                                   span={2}>{theRDData.research_development_by_pk.hcod}</Descriptions.Item>
                <Descriptions.Item label="研发活动名称"
                                   span={2}>{theRDData.research_development_by_pk.yproductName}</Descriptions.Item>
            </Descriptions>
            <div style={{padding: '10px'}}></div>
            <Form
                name="basic"
                labelCol={{
                    span: 32,
                }}
                wrapperCol={{
                    span: 32,
                }}
                style={{
                    maxWidth: 800,
                }}
                layout="vertical"
                initialValues={yfhdInitialValues}
                // layout={'inline'}
                onFinish={(values) => {
                    for (let k of 研究经费总预算字段) {
                        if (values[k]) {
                            values[k] = string10000ToMoney(values[k])
                        }
                    }
                    update_research_development_by_pk({
                        variables: {
                            id: value,
                            research_development: values,
                        }
                    }).fankui()

                }}
                onFinishFailed={(e) => {
                    console.error(e)
                }}
                autoComplete="off"
                form={form}
            >
                <Form.Item
                    label="研发活动编号 RD"
                    name="hcod"
                    rules={[{required: true, message: '请输入内容'}]}
                >
                    <Input/>
                </Form.Item>
                <Form.Item
                    label="研发活动名称"
                    name="yproductName"
                    rules={[{required: true, message: '请输入内容'}]}
                >
                    <Input/>
                </Form.Item>
                <Form.Item
                    label="开始日期"
                    name="dataEprPQzsj"
                    rules={[{required: true, message: '请输入开始日期'}]}
                    style={{display: 'inline-flex', width: '50%'}}

                >
                    <DatePicker/>
                </Form.Item>
                <Form.Item
                    label="结束日期"
                    name="dataEprPJssj"
                    rules={[{required: true, message: '请输入结束日期'}]}
                    style={{display: 'inline-flex', width: '50%'}}

                >
                    <DatePicker/>
                </Form.Item>
                <Form.Item
                    label="技术来源"
                    name="jslyList"
                    rules={[{required: true, message: '请选择内容'}]}
                >
                    <Select>
                        <Select.Option value="请选择">请选择</Select.Option>
                        <Select.Option value="企业自有技术">企业自有技术</Select.Option>
                        <Select.Option value="大专院校">大专院校</Select.Option>
                        <Select.Option value="地方属科研院所">地方属科研院所</Select.Option>
                        <Select.Option value="其他企业技术">其他企业技术</Select.Option>
                        <Select.Option value="引进技术本企业消化创新">引进技术本企业消化创新</Select.Option>
                        <Select.Option value="国外技术">国外技术</Select.Option>
                        <Select.Option value="中央属科研院所">中央属科研院所</Select.Option>

                    </Select>
                </Form.Item>
                {/*<Form.Item*/}
                {/*    label="研究经费总预算（万元）"*/}
                {/*    name="spending"*/}
                {/*    rules={[{required: true, message: '请输入内容'}]}*/}
                {/*>*/}
                {/*    <Input/>*/}
                {/*</Form.Item>*/}
                {/*<Form.Item*/}
                {/*    label="研究经费近三年总支出（万元）"*/}
                {/*>*/}

                {/*<Form.Item*/}
                {/*    label="总计（万元）"*/}
                {/*    name="yfjfzzc"*/}
                {/*    rules={[{ message: '请输入内容'}]}*/}
                {/*    style={{display:'inline-flex' ,width:'50%'}}*/}
                {/*>*/}
                {/*    <Input/>*/}
                {/*</Form.Item>*/}
                {/*<Form.Item*/}
                    {/*    label="其中（2020）"*/}
                    {/*    name="zc1"*/}
                    {/*    rules={[{ message: '请输入内容'}]}*/}
                    {/*    style={{display:'inline-flex' ,width:'50%'}}*/}
                    {/*>*/}
                    {/*    <Input/>*/}
                    {/*</Form.Item>*/}
                    {/*<Form.Item*/}
                    {/*    label="其中（2021）"*/}
                    {/*    name="zc2"*/}
                    {/*    rules={[{ message: '请输入内容'}]}*/}
                    {/*    style={{display:'inline-flex' ,width:'50%'}}*/}

                    {/*>*/}
                    {/*    <Input/>*/}
                    {/*</Form.Item>*/}
                    {/*<Form.Item*/}
                {/*    label="其中（2022）"*/}
                {/*    name="zc3"*/}
                {/*    rules={[{ message: '请输入内容'}]}*/}
                {/*    style={{display:'inline-flex' ,width:'50%'}}*/}

                {/*>*/}
                {/*    <Input/>*/}
                {/*</Form.Item>*/}
                {/*<Row gutter={24}>{getFields()}</Row>*/}

                {/*</Form.Item>*/}
                <h3>科技人员</h3>
                <Space>{theRDData.research_development_by_pk.players.map(p => p.playerObj).map(p => <Tag
                    color="default">{p.name}</Tag>)}</Space>
                <div style={{padding: '10px'}}></div>
                <Space>
                    <Button onClick={() => {
                        inputs(form).map(i => chatAI(i[2], form.getFieldValue(i[1]), (answer) => form.setFieldValue(i[1], answer)))
                    }}>一键 ChatGPT</Button>
                    <Button onClick={() => {
                        inputs(form).map(i => chatAI(i[2], form.getFieldValue(i[1]), (answer) => form.setFieldValue(i[1], answer)), 'bing')
                    }}>一键 Bing</Button>
                </Space>
                {inputs(form).map((i, index) => <>
                    <Form.Item
                        label={i[0]}
                        name={i[1]}
                        rules={[{required: true, message: i[0]}]}
                    >
                        <TextArea showCount autoSize/>
                    </Form.Item>
                    <Space>
                        <Button onClick={() => {
                            const i = inputs(form)[index]
                            chatAI(i[2], form.getFieldValue(i[1]), (answer) => form.setFieldValue(i[1], answer))
                        }}>ChatGPT</Button>
                        <Button onClick={() => {
                            const i = inputs(form)[index]
                            chatAI(i[2], form.getFieldValue(i[1]), (answer) => form.setFieldValue(i[1], answer), 'bing')
                        }}>Bing</Button>
                    </Space>
                </>)}

                <Form.Item wrapperCol={{offset: 8, span: 8}}>
                    <Button type="primary" htmlType="submit">
                        确定
                    </Button>
                </Form.Item>
                <h3>研究立项书</h3>
                <PrintPDF html={`
<div style="line-height: 2em;">
<div class ="title"; style="font-family: SimSun;">
<div style="color: red">
<h1 style="text-align: center">${theRDData.research_development_by_pk.mndsbObj.companyObj.qymc}</h1>
<h4 style="text-align: end">（${theRDData.research_development_by_pk.mndsbObj.companyObj.qyjc}）研批字【${new Date(theRDData.research_development_by_pk.dataEprPQzsj).getFullYear()}】0${theRDData.research_development_by_pk.hcod}号</h4>
<hr style="border-color:red"/>
</div>
<br/>
<h3 style="text-align: center">
${theRDData.research_development_by_pk.yproductName}立项批复的通知
</h3>
<text>
公司各部门：<br/>
<p style="text-indent:30px">
为提高公司${theRDData.research_development_by_pk.yproductName}，降低成本，操作方便，统一管理。现下达${theRDData.research_development_by_pk.yproductName}，此项目具体事宜由公司研发中心负责，公司各相关部门配合。
<br/>
特立此批复！
<br>
</text>
<div class="date" style="direction: rtl;unicode-bidi: embed;">
<text > ${theRDData.research_development_by_pk.mndsbObj.companyObj.qymc} 
</text><br>
 ${new Date(theRDData.research_development_by_pk.dataEprPQzsj).toLocaleDateString()}
<p/>
</div>
<div style="padding-top: 200px">
主题词：研发
<hr style="border-color:black" />
<div  style="display: flex;justify-content: space-between;">
  <div>${theRDData.research_development_by_pk.mndsbObj.companyObj.qymc} </div>
  <div>研发办 ${new Date(theRDData.research_development_by_pk.dataEprPQzsj).toLocaleDateString()}</div>
</div>
<hr style="border-color:black" />
<div>抄送：财务部、管理部、设计开发部
<hr style="border-color:black" />
</div></div>
</div>
<div style="page-break-after: always;"></div>


<div style="font-family: SimSun;font-size: 16pt;">
<h2 style="text-align: center;padding-top: 30px">${theRDData.research_development_by_pk.yproductName}开发</h2>
<div style="text-align: center ; font-size: 70px; padding: 60px;line-height: 80px;">立<br>项<br>报<br>告</div>
<div style="padding-top: 100px">
<div style="text-align: center">编制:<span style="text-decoration: underline; ">项目研发部</span></div>
<div style="text-align: center ;">审核:<span style="text-decoration: underline; ">公司董事会</span></div>
<div style="text-align: center; padding-top: 100px">${new Date(theRDData.research_development_by_pk.dataEprPQzsj).toLocaleDateString()}</div>
</div>
</div>
<div style="page-break-after: always;"></div>

<div style="font-family: SimSun;font-size: 16pt;"> 
<h3>一、项目研究背景和必要性</h3>
<p style="text-indent: 2em;margin: 0;">${(theRDData.research_development_by_pk.XMYJBJHBYX || '').split('\n').join('</p><p style="text-indent: 2em;margin: 0;">')}</p>
<div style="page-break-after: always;"></div>
<h3>二、研究内容、技术路线和创新点</h3>
<p style="text-indent: 2em;margin: 0;">${(theRDData.research_development_by_pk.YJNRHXJSHCXD || '').split('\n').join('</p><p style="text-indent: 2em;margin: 0;">')}</p>
<div style="page-break-after: always;"></div>
<h3>三、预期目标及考核指标</h3>
<p style="text-indent: 2em;margin: 0;">${(theRDData.research_development_by_pk.YQMBJKHZB || '').split('\n').join('</p><p style="text-indent: 2em;margin: 0;">')}</p>
</div>
<div style="page-break-after: always;"></div>
<div style="font-family: SimSun;font-size: 16pt; "> 
<h3>四、实施进度计划和阶段目标</h3>
${((theRDData.research_development_by_pk.SSJDJHHJDMB || '').split('```')[1] || '').replace('<table>', '<table style="border-collapse: collapse; width: 100%; border-spacing: 0px; border: 1px solid rgb(0, 0, 0); margin-left: auto; margin-right: auto;">').split('<th>').join('<th style="border: 1px solid rgb(0, 0, 0); padding: 0; text-align: center">').split('<td>').join('<td style="border: 1px solid rgb(0, 0, 0); padding: 0; text-align: center">')}
<!--<table  border="1" style="border-collapse:separate; width: 780px; border-spacing: 3px;">-->
<!--<thead>-->
<!--<tr>-->
<!--      <th>序号</th>-->
<!--      <th>开始时间</th>-->
<!--      <th>完成时间</th>-->
<!--      <th>进度安排和阶段目标</th>-->
<!--      <th>技术内容</th>-->
<!--    </tr>-->
<!--</thead>-->
<!-- <tbody>-->
<!--    <tr>-->
<!--      <td style="text-align: center">1</td>-->
<!--      <td style="text-align: center">2022年1月</td>-->
<!--      <td style="text-align: center">2022年3月</td>-->
<!--      <td style="text-align: center">确定研究方向和目标</td>-->
<!--      <td style="text-align: center">局部放电检测技术研究现状分析、问题和挑战</td>-->
<!--    </tr>-->
<!--    <tr>-->
<!--      <td style="text-align: center">2</td>-->
<!--      <td style="text-align: center">2022年4月</td>-->
<!--      <td style="text-align: center">2022年6月</td>-->
<!--      <td style="text-align: center">确定检测技术方案和参数</td>-->
<!--      <td style="text-align: center">检测技术方案制定和参数优化</td>-->
<!--    </tr>-->
<!--    <tr>-->
<!--      <td style="text-align: center">3</td>-->
<!--      <td style="text-align: center">2022年7月</td>-->
<!--      <td style="text-align: center">2022年9月</td>-->
<!--      <td style="text-align: center">设计实验方案</td>-->
<!--      <td style="text-align: center">实验方案设计和制定</td>-->
<!--    </tr>-->
<!--    <tr>-->
<!--      <td style="text-align: center">4</td>-->
<!--      <td style="text-align: center">2022年10月</td>-->
<!--      <td style="text-align: center">2022年11月</td>-->
<!--      <td style="text-align: center">实验测试</td>-->
<!--      <td style="text-align: center">针对不同设备进行局部放电测试和分析</td>-->
<!--    </tr>-->
<!--    <tr>-->
<!--      <td style="text-align: center">5</td>-->
<!--      <td style="text-align: center">2022年12月</td>-->
<!--      <td style="text-align: center">2022年12月</td>-->
<!--      <td style="text-align: center">数据分析和总结</td>-->
<!--      <td style="text-align: center">局部放电检测数据分析和总结，制定下一步研究计划</td>-->
<!--    </tr>-->
<!--  </tbody>-->
<!--</table>-->
</div>
<div style="page-break-after: always;"></div>
<div style="font-family: SimSun;font-size: 16pt;   "> 
<h3>五、预期产生的经济效益分析</h3>
<p style="text-indent: 2em;margin: 0;">${(theRDData.research_development_by_pk.YQCSDJJXYFX || '').split('\n').join('</p><p style="text-indent: 2em;margin: 0;">')}</p>
</div>
<div style="page-break-after: always;"></div>
<div style="font-family: SimSun; font-size: 16pt;">
<h3>六、项目组织方式</h3>
<p style="text-indent: 2em;margin: 0;">项目组由总经理直接负责，以${(yfry.cy[0] || {}).name}为项目组长，具体人员结构如下：</p>
<table style="border-collapse: collapse; width: 100%; border-spacing: 0px; border: 1px solid rgb(0, 0, 0); margin-left: auto; margin-right: auto;" border="1">
<thead>
<tr>
<th style="border-width: 1px; padding: 0px; border-color: rgb(0, 0, 0);">所属部门</th>
<th style="border-width: 1px; padding: 0px; border-color: rgb(0, 0, 0);">姓名</th>
<th style="border-width: 1px; padding: 0px; border-color: rgb(0, 0, 0);">职务</th>
<th style="border-width: 1px; padding: 0px; border-color: rgb(0, 0, 0);">工作内容</th>
</tr>
</thead>
<tbody>
${yfry.cy.map((cy, index) => `
<tr>
<td style="border-width: 1px; padding: 0px; border-color: rgb(0, 0, 0);text-align: center">研发部</td>
<td style="border-width: 1px; padding: 0px; border-color: rgb(0, 0, 0);text-align: center">${cy.name}</td>
<td style="border-width: 1px; padding: 0px; border-color: rgb(0, 0, 0);text-align: center">${研发职务工作内容[index][0]}</td>
<td style="border-width: 1px; padding: 0px; border-color: rgb(0, 0, 0);text-align: center">${研发职务工作内容[index][1]}</td>
</tr>
`).join('')}
</tbody>
</table>
</div>
<div style="page-break-after: always;"></div>
<div style="font-family: SimSun; font-size: 16pt;">
<h3>七、研究开发费用预算报告</h3>
<div style="direction: rtl; unicode-bidi: embed;">所属年度：${new Date(theRDData.research_development_by_pk.dataEprPQzsj).format("yyyy")}年</div>
<table style="border-collapse: collapse; width: 100%; border-spacing: 0px; border: 1px solid rgb(0, 0, 0); margin-left: auto; margin-right: auto;" border="1">
<tbody>
<tr>
<td style="text-align: center; border-width: 1px; padding: 0px; border-color: rgb(0, 0, 0);text-align: center" colspan="3">项目期间（${new Date(theRDData.research_development_by_pk.dataEprPQzsj).format("yyyy年MM月")}-${new Date(theRDData.research_development_by_pk.dataEprPJssj).format("yyyy年MM月")}）</td>
</tr>
<tr>
<th style="border-width: 1px; padding: 0px; border-color: rgb(0, 0, 0);text-align: center">项目</th>
<th style="border-width: 1px; padding: 0px; border-color: rgb(0, 0, 0);text-align: center">费用（万元）</th>
<th style="border-width: 1px; padding: 0px; border-color: rgb(0, 0, 0);text-align: center">明细</th>
</tr>
${内部研究开发费用说明.filter(sm => kffyys[sm[0]] > 0).map(sm => `
<tr>
<td style="border-width: 1px; padding: 0px; border-color: rgb(0, 0, 0);text-align: center">${sm[1]}</td>
<td style="border-width: 1px; padding: 0px; border-color: rgb(0, 0, 0);text-align: center">${kffyys[sm[0]]}</td>
<td style="border-width: 1px; padding: 0px; border-color: rgb(0, 0, 0);text-align: center">${sm[2]}</td>
</tr>
`).join('')}
<!--<tr>-->
<!--<td style="border-width: 1px; padding: 0px; border-color: rgb(0, 0, 0);text-align: center">人员人工</td>-->
<!--<td style="border-width: 1px; padding: 0px; border-color: rgb(0, 0, 0);text-align: center">&nbsp;</td>-->
<!--<td style="border-width: 1px; padding: 0px; border-color: rgb(0, 0, 0);text-align: center">直接从事研发活动的本企业在职人员费用</td>-->
<!--</tr>-->
<!--<tr>-->
<!--<td style="border-width: 1px; padding: 0px; border-color: rgb(0, 0, 0);text-align: center">直接投入</td>-->
<!--<td style="border-width: 1px; padding: 0px; border-color: rgb(0, 0, 0);text-align: center">&nbsp;</td>-->
<!--<td style="border-width: 1px; padding: 0px; border-color: rgb(0, 0, 0);text-align: center">研发活动直接消耗的材料、燃料和动力费用</td>-->
<!--</tr>-->
<!--<tr>-->
<!--<td style="border-width: 1px; padding: 0px; border-color: rgb(0, 0, 0);text-align: center">折旧费</td>-->
<!--<td style="border-width: 1px; padding: 0px; border-color: rgb(0, 0, 0);text-align: center">&nbsp;</td>-->
<!--<td style="border-width: 1px; padding: 0px; border-color: rgb(0, 0, 0);text-align: center">专门用于研发活动的相关设备的折旧费</td>-->
<!--</tr>-->
<!--<tr>-->
<!--<td style="border-width: 1px; padding: 0px; border-color: rgb(0, 0, 0);text-align: center">装备调试费</td>-->
<!--<td style="border-width: 1px; padding: 0px; border-color: rgb(0, 0, 0);text-align: center">&nbsp;</td>-->
<!--<td style="border-width: 1px; padding: 0px; border-color: rgb(0, 0, 0);text-align: center">专门用于中间实验和综合性能测试的样品费及各项送检费用</td>-->
<!--</tr>-->
<!--<tr>-->
<!--<td style="border-width: 1px; padding: 0px; border-color: rgb(0, 0, 0);text-align: center">其他费用</td>-->
<!--<td style="border-width: 1px; padding: 0px; border-color: rgb(0, 0, 0);text-align: center">&nbsp;</td>-->
<!--<td style="border-width: 1px; padding: 0px; border-color: rgb(0, 0, 0);text-align: center">与研发活动直接相关的其它费用</td>-->
<!--</tr>-->
<tr>
<td style="border-width: 1px; padding: 0px; border-color: rgb(0, 0, 0);text-align: center">合计</td>
<td style="border-width: 1px; padding: 0px; border-color: rgb(0, 0, 0);text-align: center">${kffyys.sum}</td>
<td style="border-width: 1px; padding: 0px; border-color: rgb(0, 0, 0);text-align: center ">&nbsp;</td>
</tr>
</tbody>
</table>
</div>
<div  style="font-family: SimSun;font-size: 12pt; ">
<p>填写说明：</p>
<p style="text-indent: 2em;margin: 0;">
1.科研项目要按照《研发费用核算管理制度》严格执行，以项目为单位实行专项管理。
技术研发部以科研项目预期发生的支出为依据，负责编制科研项目经费预算，不得重复预算，
并应当扣除已经通过其他途径列支费用。管理费不得超过项目总经费的10%，外委经费一般不超过项目总经费的30%。 
</p>
<p style="text-indent: 2em;margin: 0;">
2.财务部要按项目进度计划分期拨给，确保科研工作的资金流保持通畅，并按公司相关规定建立研发费用辅助台账，专款专用。
</p>
<p style="text-indent: 2em;margin: 0;">
3.科研项目经费必须严格按照经批准的经费预算执行和管理，由技术研发部总体掌握，财务结算中心监督，
不准挪作它用，每期费用超过预算的5%要报请技术负责人批准。科技项目经费在项目执行期可跨年使用。
</p>
</div>
<div style="page-break-after: always;"></div>
<div style="font-family: SimSun; font-size: 12pt;">
<h1 style="text-align: center; padding-top: 0px;">设计评审报告</h1>
<table style="border-collapse: collapse; width: 100%; border-spacing: 0px; border: 1px solid rgb(0, 0, 0); margin-left: auto; margin-right: auto; height: 680.157px;" border="1">
<tbody>
<tr style="height: 40.8594px;">
<td style="text-align: center; border-width: 1px; padding: 0px; border-color: rgb(0, 0, 0); height: 40.8594px;">项目名称及规格型号</td>
<td style="text-align: center; border-width: 1px; padding: 0px; border-color: rgb(0, 0, 0); height: 40.8594px;">${theRDData.research_development_by_pk.yproductName}</td>
<td style="text-align: center; border-width: 1px; padding: 0px; border-color: rgb(0, 0, 0); height: 40.8594px;">评审组长</td>
<td style="text-align: center; border-width: 1px; padding: 0px; border-color: rgb(0, 0, 0); height: 40.8594px;">${(yfry.ps[0] || {}).name}</td>
</tr>
<tr style="height: 47.1875px;">
<td style="text-align: center; border-width: 1px; padding: 0px; border-color: rgb(0, 0, 0); height: 47.1875px;">任务来源</td>
<td style="text-align: center; border-width: 1px; padding: 0px; border-color: rgb(0, 0, 0); height: 47.1875px;" colspan="3">市场需求</td>
</tr>
<tr style="height: 96.5938px;">
<td style="text-align: center; border-width: 1px; padding: 0px; border-color: rgb(0, 0, 0); height: 96.5938px;">评审组长、参加评审人员</td>
<td style="text-align: center; border-width: 1px; padding: 0px; border-color: rgb(0, 0, 0); height: 96.5938px;" colspan="3">${yfry.ps.map((cy, index) => cy.name).join('、')}</td>
</tr>
<tr style="height: 106px;">
<td style="border-width: 1px; padding: 0px; border-color: rgb(0, 0, 0); height: 106px;" colspan="4">
<p>评审内容：</p>
<p>研发${theRDData.research_development_by_pk.yproductName}方案的可靠性及可行性</p>
</td>
</tr>
<tr style="height: 194.188px;">
<td style="border-width: 1px; padding: 0px; border-color: rgb(0, 0, 0); height: 194.188px;" colspan="4">
<p>评审结论：</p>
<p>该项目设计合理，符合使用要求，且性能可靠、可行性高。经评审一致同意该研发方案</p>
</td>
</tr>
<tr style="height: 195.328px;">
<td style="border-width: 1px; padding: 0px; border-color: rgb(0, 0, 0); height: 195.328px;" colspan="4">
<p>对纠正、改进措施的跟踪验证结果：</p>
<p>完善技术方案相关技术资料，制定实施进度计划。</p>
</td>
</tr>
</tbody>
</table>
<p>备注：1、评审会议记录应保留；2、可另行加页叙述。</p>
</div>
<div style="page-break-after: always;"></div>

<div style="font-family: SimSun; font-size: 12pt;">
<h1 style="text-align: center; padding-top: 0px;">中期项目进度报告</h1>
<table style="border-collapse: collapse; width: 100%; border-spacing: 0px; border: 1px solid rgb(0, 0, 0); margin-left: auto; margin-right: auto; height: 536.531px;" border="1">
<tbody>
<tr style="height: 29.125px;">
<td style="text-align: center; border-width: 1px; padding: 0px; border-color: rgb(0, 0, 0); height: 29.125px;">项目名称</td>
<td style="text-align: center; border-width: 1px; padding: 0px; border-color: rgb(0, 0, 0); height: 29.125px;" colspan="6">${theRDData.research_development_by_pk.yproductName}</td>
</tr>
<tr style="height: 22.3906px;">
<td style="border-width: 1px; padding: 0px; border-color: rgb(0, 0, 0); height: 507.406px;" rowspan="7">
<p style="text-align: center; align-items: center;"><span style="font-family: SimSun; font-size: 22pt;writing-mode:vertical-lr;padding: 30px;">项目进展情况</span></p>
</td>
<td style="text-align: center; border-width: 1px; padding: 0px; border-color: rgb(0, 0, 0); height: 22.3906px;" colspan="2">是否制定实施方案或计划</td>
<td style="text-align: center; border-width: 1px; padding: 0px; border-color: rgb(0, 0, 0); height: 22.3906px;" colspan="4">（ &radic; ）是 （ ）否</td>
</tr>
<tr style="height: 22.3906px;">
<td style="text-align: center; border-width: 1px; padding: 0px; border-color: rgb(0, 0, 0); height: 22.3906px;" colspan="2">研发团队情况</td>
<td style="text-align: center; border-width: 1px; padding: 0px; border-color: rgb(0, 0, 0); height: 22.3906px;" colspan="4">共有（${yfry.cy.length}）人，负责人（${(yfry.cy[0] || {}).name}）</td>
</tr>
<tr style="height: 142.719px;">
<td style="border-width: 1px; padding: 0px; border-color: rgb(0, 0, 0); height: 142.719px;" colspan="6">研究或开发进展情况：经查阅大量的相关资料后，目前已经确定项目总体方案及系统设计方案，目前正处于测试实验阶段。</td>
</tr>
<tr style="height: 252.734px;">
<td style="border-width: 1px; padding: 0px; border-color: rgb(0, 0, 0); height: 252.734px;" colspan="6">
<p>实现的主要技术指标：</p>
${(theRDData.research_development_by_pk.PQdcg || '').split('\n').join('<br/>')}
</td>
</tr>
</tbody>
</table>
</div>
<div style="page-break-after: always;"></div>
<div style="font-family: SimSun; font-size: 12pt;">
<h1 style="text-align: center; padding-top: 0px;">科技项目验收申请单</h1>
<p>申请单位：项目研发部</p>
<table style="border-collapse: collapse; width: 100%; border: 1px solid rgb(0, 0, 0); margin-left: auto; margin-right: auto;" border="1">
<tbody>
<tr style="height:45.9500pt;">
<td style="text-align: center; border-width: 1px; border-color: rgb(0, 0, 0);" colspan="2">项目名称</td>
<td style="text-align: center; border-width: 1px; border-color: rgb(0, 0, 0);" colspan="3">${theRDData.research_development_by_pk.yproductName}</td>
</tr>
<tr style="height:45.9000pt;">
<td style="text-align: center; border-width: 1px; border-color: rgb(0, 0, 0);" colspan="2">项目负责人</td>
<td style="text-align: center; border-width: 1px; border-color: rgb(0, 0, 0);">${(yfry.cy[0] || {}).name}</td>
<td style="text-align: center; border-width: 1px; border-color: rgb(0, 0, 0);">项目完成时间</td>
<td style="text-align: center; border-width: 1px; border-color: rgb(0, 0, 0);">${new Date(theRDData.research_development_by_pk.dataEprPJssj).toLocaleDateString()}</td>
</tr>
<tr style="height: 22.3906px;">
<td style="text-align: center; border-width: 1px; padding: 0px; border-color: rgb(0, 0, 0); height: 44.7812px;" rowspan="1" colspan="4">项目自执行期开始至今完成投入（万元）</td>
<td style="text-align: center; border-width: 1px; padding: 0px; border-color: rgb(0, 0, 0); height: 44.7812px;" rowspan="1" colspan="1">${money10000ToString(kffy.sum || 0)}</td>
</tr>
<td style="text-align: center; border-width: 1px; padding: 0px; border-color: rgb(0, 0, 0); height: 22.3906px;" rowspan="8">其中</td>
<!--<tr style="height: 22.3906px;">-->
${内部研究开发费用说明.filter(sm => kffyys[sm[0]] > 0).map(sm => `<tr style="height: 22.3906px;">
<td style="text-align: center; border-width: 1px; padding: 0px; border-color: rgb(0, 0, 0); height: 22.3906px;" colspan="3">${sm[1]}</td>
<td style="text-align: center; border-width: 1px; padding: 0px; border-color: rgb(0, 0, 0); height: 22.3906px;" colspan="1" rowspan="1">${money10000ToString(kffy[sm[0]] || 0)}</td>
</tr>`).join('')}
<!--<td style="text-align: center; border-width: 1px; padding: 0px; border-color: rgb(0, 0, 0); height: 22.3906px;" colspan="1">折旧费</td>-->
<!--<td style="text-align: center; border-width: 1px; padding: 0px; border-color: rgb(0, 0, 0); height: 22.3906px;">能源材料费</td>-->
<!--<td style="text-align: center; border-width: 1px; padding: 0px; border-color: rgb(0, 0, 0); height: 22.3906px;">人员人工费</td>-->
<!--<td style="text-align: center; border-width: 1px; padding: 0px; border-color: rgb(0, 0, 0); height: 22.3906px;">其他</td>-->
<!--</tr>-->
<!--<tr style="height: 22.3906px;">-->
<!--<td style="text-align: center; border-width: 1px; padding: 0px; border-color: rgb(0, 0, 0); height: 22.3906px;">&nbsp;</td>-->
<!--<td style="text-align: center; border-width: 1px; padding: 0px; border-color: rgb(0, 0, 0); height: 22.3906px;" colspan="1">&nbsp;</td>-->
<!--<td style="text-align: center; border-width: 1px; padding: 0px; border-color: rgb(0, 0, 0); height: 22.3906px;">&nbsp;</td>-->
<!--<td style="text-align: center; border-width: 1px; padding: 0px; border-color: rgb(0, 0, 0); height: 22.3906px;">&nbsp;</td>-->
<!--<td style="text-align: center; border-width: 1px; padding: 0px; border-color: rgb(0, 0, 0); height: 22.3906px;">&nbsp;</td>-->
<!--</tr>-->
<tr style="height:46.5000pt;">
<td style="text-align: center; border-width: 1px; border-color: rgb(0, 0, 0);" colspan="3">项目执行期</td>
<td style="text-align: center; border-width: 1px; border-color: rgb(0, 0, 0);" colspan="2">${new Date(theRDData.research_development_by_pk.dataEprPQzsj).toLocaleDateString()}&mdash;&mdash;${new Date(theRDData.research_development_by_pk.dataEprPJssj).toLocaleDateString()}</td>
</tr>
<tr style="height:252.3500pt;">
<td style="border-width: 1px; border-color: rgb(0, 0, 0);" colspan="5">
<!--<p style="height:28.0000pt">取得的阶段性成果：</p>-->
<!--<p style="height:28.0000pt"></p>-->
<p style="">项目申请验收理由：</p>
<p style="text-indent: 2em;height:28.0000pt">关于项目${theRDData.research_development_by_pk.yproductName}按时间完成项目设计改进，现已完成了项目内容，经测试和试运行合格，现申请验收。</p>
<div style="text-align: right;height:28.0000pt;">${new Date(theRDData.research_development_by_pk.dataEprPJssj).toLocaleDateString()}</div>
</td>
</tr>
</tbody>
</table>
</div>
<div style="page-break-after: always;"></div>
<div style="font-family: SimSun; font-size: 12pt;">
<h1 style="text-align: center; padding-top: 0px;">${theRDData.research_development_by_pk.yproductName}科研项目验收鉴定表</h1>
<table style="border-collapse: collapse; width: 100%;  border: 1px solid rgb(0, 0, 0); margin-left: auto; margin-right: auto;" border="1">
<tbody>
<tr style="height:20.6000pt;">
<td style="text-align: center; border-width: 1px; border-color: rgb(0, 0, 0);">科研项目名称</td>
<td style="text-align: center; border-width: 1px; border-color: rgb(0, 0, 0);" colspan="5">${theRDData.research_development_by_pk.yproductName}</td>
</tr>
<tr style="height:22.6000pt;">
<td style="text-align: center; border-width: 1px; border-color: rgb(0, 0, 0);">项目承担部门</td>
<td style="text-align: center; border-width: 1px; border-color: rgb(0, 0, 0);">研发部</td>
<td style="text-align: center; border-width: 1px; border-color: rgb(0, 0, 0);">负责人</td>
<td style="text-align: center; border-width: 1px; border-color: rgb(0, 0, 0);">${(yfry.cy[0] || {}).name}</td>
<td style="text-align: center; border-width: 1px; border-color: rgb(0, 0, 0);">申请日期</td>
<td style="text-align: center; border-width: 1px; border-color: rgb(0, 0, 0);">${new Date(theRDData.research_development_by_pk.dataEprPJssj).toLocaleDateString()}</td>
</tr>
<tr style="height:87.0000pt;">
<td style="border-width: 1px; border-color: rgb(0, 0, 0);" colspan="6">
<p style="text-indent: 2em;margin: 0;">1.科研项目主要内容：</p>
<p style="text-indent: 2em;margin: 0;">本项目已实现了${theRDData.research_development_by_pk.yproductName}的研究开发，实现了降低成本，操作方便，实现统一管理。在各项设计指标上，经检测，达到预期设计指标。</p>
<p style="text-indent: 2em;margin: 0;">2.项目获得的技术成果内容：</p>
<p style="text-indent: 2em;margin: 0;">本项目已成功研发出产品，同时经过客户使用，各项性能均得到了客户的高度评价。</p>
</td>
</tr>
<tr style="height:66.7000pt;">
<td style="border-width: 1px; border-color: rgb(0, 0, 0);" colspan="6">
<p style="text-indent: 1em;">研发部验收意见：</p>
</br>
</br>
<div style="display: flex; flex-direction: row; flex-wrap: wrap; justify-content: space-between;">
<div>&nbsp;</div>
<div>部门负责人（签章）</div>
<div style="padding-right: 3em;">${new Date(theRDData.research_development_by_pk.dataEprPJssj).toLocaleDateString()}</div>
</div>
</td>
</tr>
<tr style="height:66.7000pt;">
<td style="border-width: 1px; border-color: rgb(0, 0, 0);" colspan="6">
<p style="text-indent: 1em;">测试部验收意见：</p>
</br>
</br>
<div style="display: flex; flex-direction: row; flex-wrap: wrap; justify-content: space-between;">
<div>&nbsp;</div>
<div>&nbsp;</div>
<div style="padding-right: 3em;">${new Date(theRDData.research_development_by_pk.dataEprPJssj).toLocaleDateString()}</div>
</div>
</td>
</tr>
<tr style="height:67.2500pt;">
<td style="border-width: 1px; border-color: rgb(0, 0, 0);" colspan="6">
<p style="text-indent: 1em;">总经理办公室验收意见：</p>
</br>
</br>
<div style="display: flex; flex-direction: row; flex-wrap: wrap; justify-content: space-between;">
<div>&nbsp;</div>
<div>总经理（签章）</div>
<div style="padding-right: 3em;">${new Date(theRDData.research_development_by_pk.dataEprPJssj).toLocaleDateString()}</div>
</div>
</td>
</tr>
</tbody>
</table>
<p>此记录最终由研发部保存3年。</p>
</div>
</div>


`}/>
            </Form>
            <h3>附件 <UploadOutlined/></h3>
            <SelectUpload
                item={value}
                nameList={["科技项目立项报告", "结题报告或验收报告", "委托开发或合作开发协议"]}/>
            <Attachments attachments={theRDData.research_development_by_pk.attachments}/>
            <Paragraph>
                请上传科研项目立项证明（已验收或结题项目附验收或结题报告）相关材料。
                <br/>
                <h5>认定机构具体要求如下：</h5>
                1. 科技项目立项报告，结题报告或验收报告，委托开发或合作开发协议<br/>
                <h5>附件格式要求：</h5>

                1、证明材料扫描上传。<br/>

                2、只支持非加密PDF格式的文件上传。<br/>

                3、单个文件大小不要超过2M。
            </Paragraph>
        </>
        }
    </>)
}
